/**
 * @author Abhishek
 * @description Component to get value from source and display in the textbox
 */

import * as React from "react";
import { connect } from "react-redux";
import IProps from "./IProps";
import "../../../assets/sass/widgets/templates.scss";
import "../../../assets/sass/widgets/popup.scss";
import * as dynamicFormActionCreators from "../../components/DynamicForm/actionCreators";
import { bindActionCreators } from "redux";
import * as globalActionsCreator from "../../globalStore/actions";
import ReactGA from "react-ga";
import { handleEnter } from "../../utils/utils";
import { validateEmptyForm, imagePathurl } from "../../utils/utils";
import * as CONFIG from "../../../config.json";

/**
 * @interface IState
 * @ignore
 */
interface IState {
    isMyTemplate?: boolean;
    myTemplateTitle?: string;
    saveTemplateTitle?: string;
    buttonLabel?: string;
    buttonClass?: string;
    isStoreUpdated?: boolean;
    isManageTemaplatePopup?: any;
    checkedItems?: any;
    checkedItemsNames?: any;
    buttonState?: any;
    isLoading?: any;
    isLoaingFunc?: any;
}

/**
 * @name Template
 * @class Template
 * @description This component takes care of saving the template , displaying the saved templates , loading the saved template , deleting the templates
 * @category Widgets
 */
class SaveTemplate extends React.Component<IProps, IState, {}> {
    constructor(props) {
        super(props);
        this.state = {
            isManageTemaplatePopup: false,
            checkedItems: [],
            checkedItemsNames: [],
            buttonLabel: "LOAD TEMPLATE",
            buttonState: "-Select-",
            isLoading: false,
        };
        this.handleSaveTemplate = this.handleSaveTemplate.bind(this);
        this.handleLoadTemplate = this.handleLoadTemplate.bind(this);
        this.handleManageTemplate = this.handleManageTemplate.bind(this);
        this.updateDropDownSchema = this.updateDropDownSchema.bind(this);
        this.handleClearTemplate = this.handleClearTemplate.bind(this);
        this.onCancelPopup = this.onCancelPopup.bind(this);
        this.confirmDeleteTempalate = this.confirmDeleteTempalate.bind(this);
    }

    componentDidUpdate(prevProps, nextState) {
        if (
            this.props.formData.residentialWarrantyForm.projectDetails.warrantyType !==
            prevProps.formData.residentialWarrantyForm.projectDetails.warrantyType
        ) {
            this.setState({ buttonLabel: "LOAD TEMPLATE" });
        }
        const currentNavMenu = this.props.formData.residentialWarrantyForm && this.props.formData.residentialWarrantyForm.NavigationMenu;
        if (this.props.warrentyData !== prevProps.warrentyData) {
            const newArr = this.props.menuKeys.map((menu) => {
                if (currentNavMenu && menu[currentNavMenu] === "projectDetails") {
                    menu.visitCount = menu.visitCount + 1;
                }
                return menu;
            });
            this.props.dynamicFormActions.addTabDetailsToStore(newArr);
        }
    }

    componentDidMount() {
        const payLoad = {
            actionType: "updateDropDown",
        };
        this.props.dynamicFormActions.getTemplates({ payload: payLoad });
    }
    /**
     * @function updateDropDownSchema
     * @param e
     * @description
     * Compares the saved template and update it if not avaiable
     * @ignore
     */
    updateDropDownSchema() {
        const [loadButton] = ["LOAD TEMPLATE"];
        const { schema, savedTemplates } = this.props;
        let isTemplateMatches = false;
        const selectedTemplateId = this.props.children[0].props.formData.templates;
        const [warrantyType] = [schema.properties.templates.const.warrantyType];
        if (savedTemplates && Object.keys(savedTemplates).length && savedTemplates[warrantyType]) {
            schema.properties.templates.anyOf = [];
            for (let j = 0; j <= savedTemplates[warrantyType].length - 1; j++) {
                if (selectedTemplateId == savedTemplates[warrantyType][j].id) {
                    isTemplateMatches = true;
                }
                const storeObj = {
                    title: savedTemplates[warrantyType][j].name,
                    enum: [savedTemplates[warrantyType][j].id],
                    const: {
                        label: " ",
                        description: "",
                        placeholder: "",
                        helpText: "",
                        warrantyType: warrantyType,
                    },
                };
                schema.properties.templates.anyOf.push(storeObj);
            }
        } else {
            if (schema.properties.templates.anyOf && schema.properties.templates.anyOf.length) {
                delete schema.properties.templates.anyOf;
            }
        }
        if (!isTemplateMatches && selectedTemplateId && savedTemplates) {
            this.props.children[0].props.onChange("");
            this.setState({ buttonLabel: loadButton, isLoading: false });
        }

        return schema;
    }
    /**
     * @function handleClearTemplate
     * @param e
     * @description
     * This function will be used to clear selected Template
     * @ignore
     */
    handleClearTemplate() {
        const { dynamicFormActions } = this.props;
        const [loadButton] = ["LOAD TEMPLATE"];
        dynamicFormActions.setProjectDetails({
            value: {
                residentialWarrantyForm: {
                    projectDetails: {},
                },
                isClear: true,
            },
        });
        this.setState({ buttonState: "-Select-", buttonLabel: loadButton, isLoading: false });
    }
    /**
     * @function onCancelPopup
     * @ignore
     */
    onCancelPopup() {
        this.setState({
            isManageTemaplatePopup: !this.state.isManageTemaplatePopup,
        });
        document.body.classList.remove("hideOverflow");
    }

    /**
     * @function onCheckBoxClick
     * @ignore
     */
    onCheckBoxClick = (item, templateName, templateList) => {
        const { checkedItems, checkedItemsNames } = this.state;
        let updatedList = [];
        const updatedTemplateName = checkedItemsNames.slice();
        if (
            templateList &&
            templateList.some((itemData) => itemData.templateId === item) &&
            checkedItems.includes(item)
        ) {
            // remove an already selected item from the selectedList
            updatedList = checkedItems.filter((listItem) => listItem !== item);
            if (updatedTemplateName.indexOf(templateName) > -1) {
                const index = updatedTemplateName.indexOf(templateName);
                updatedTemplateName.splice(index, 1);
            }
        } else {
            // add an item into the selectedList
            updatedList = [...checkedItems];
            updatedList.push(item);
            updatedTemplateName.push(templateName);
        }
        this.setState({ checkedItems: updatedList, checkedItemsNames: updatedTemplateName });
    };

    failureCallbackhandler = (data) => {
        const { children } = this.props;
        let commonErrorMsg = "";
        if (data && data.response && data.response.data && data.response.data.Message) {
            commonErrorMsg = data.response.data.Message;
            window["AppInsightTrace"].trackException(`on template save Failure: ${commonErrorMsg} `);
        } else {
            const globalErrorMsg = this.props.globalActions.showGlobalError(
                (data && data.response && data.response.data) || ""
            );
            commonErrorMsg = globalErrorMsg.payload.errorMessage;
            window["AppInsightTrace"].trackException(`on template save global Failure: ${commonErrorMsg}`);
        }
        ReactGA.event({
            category: "templates",
            action: "templates: save template",
            label: `templates: save template: ${children[0].props.formData.templates} not saved - ${commonErrorMsg}`,
        });
    };
    /**
     * @function confirmDeleteTempalate
     * @ignore
     */
    confirmDeleteTempalate() {
        const { schema, formData, dynamicFormActions } = this.props;
        const deleteitem = this.state.checkedItems;
        const successCallBack = (data) => {
            window["AppInsightTrace"].trackTrace(`on delete template successCallBack`);
            ReactGA.event({
                category: "templates",
                action: "templates: delete template",
                label: `templates: delete template: ${this.state.checkedItemsNames.join(",")}`,
            });
            this.setState({ checkedItems: [], checkedItemsNames: [] });
            this.setState({
                isManageTemaplatePopup: false,
            });
        };
        const failureCallback = (data) => {
            this.failureCallbackhandler(data);
        };
        const payLoad = {
            templateData: JSON.stringify(formData),
            WarrentyTypeCode: schema["properties"]["templates"]["const"]["warrantyType"],
            templateIds: deleteitem.toString(),
            successCallBack: successCallBack,
            failureCallback: failureCallback,
        };
        dynamicFormActions.deleteTemplates({ payload: payLoad });

        document.body.classList.remove("hideOverflow");
    }
    /**
     * @function manageTemplate
     * @param e
     * @description
     * This function will be used to remove the templates
     * @ignore
     */
    handleManageTemplate() {
        const { schema } = this.props;
        const payLoad = {
            formlayoutId: 1,
            WarrentyTypeCode: schema["properties"]["templates"]["const"]["warrantyType"],
            templateId: "",
            actionType: "manageTemplate",
        };
        this.props.dynamicFormActions.getTemplates({ payload: payLoad });
        this.setState({
            isManageTemaplatePopup: !this.state.isManageTemaplatePopup,
        });
        document.body.classList.add("hideOverflow");
    }

    /**
     * @function loadTemplate
     * @param e
     * @description
     * This function will be used to remove the templates
     * @ignore
     */
    handleLoadTemplate() {
        const { children, schema, formData, warrantyId, dynamicFormActions, formId } = this.props;
        const [loadButton, changeButton] = ["LOAD TEMPLATE", "CHANGE TEMPLATE"];
        const successCallBack = (data) => {
            this.props.dynamicFormActions.getErrorResponseOnNavChange({
                id: warrantyId ? warrantyId : formId,
            });
            if (this.state.buttonLabel === loadButton) {
                window["AppInsightTrace"].trackTrace(`on load template successCallBack`);
                ReactGA.event({
                    category: "templates",
                    action: "templates: load template finish",
                    label: `templates: load template: ${data.templateName} successfully loaded`,
                });
            }
            if (this.state.buttonState !== children[0].props.formData.templates) {
                this.setState({ buttonLabel: changeButton });
                this.setState({ buttonState: children[0].props.formData.templates });
            }
        };
        const failureCallback = (data) => {
            let commonErrorMsg = "";
            let tempBtnName = "";
            if (this.state.buttonLabel === loadButton) {
                tempBtnName = "load";
            } else if (this.state.buttonLabel === changeButton) {
                tempBtnName = "change";
            }
            if (data && data.response && data.response.data && data.response.data.Message) {
                commonErrorMsg = data.response.data.Message;
                window["AppInsightTrace"].trackException(`on ${tempBtnName} template Failure: ${commonErrorMsg} `);
            } else {
                const globalErrorMsg = this.props.globalActions.showGlobalError(data.response.data);
                commonErrorMsg = globalErrorMsg.payload.errorMessage;
                window["AppInsightTrace"].trackException(
                    `on ${tempBtnName} template global Failure: ${commonErrorMsg}`
                );
            }
            ReactGA.event({
                category: "templates",
                action: `templates: ${tempBtnName} template finish`,
                label: `templates: ${tempBtnName} template: ${children[0].props.formData.templates} not loaded - request cancelled - ${commonErrorMsg}`,
            });
        };
        const payLoad = {
            templateId: children[0].props.formData.templates,
            templateData: JSON.stringify(formData),
            WarrentyTypeCode: schema["properties"]["templates"]["const"]["warrantyType"],
            successCallBack: successCallBack,
            failureCallback: failureCallback,
        };
        let templateName = "";
        if (schema.properties.templates.anyOf && schema.properties.templates.anyOf.length) {
            const anyof = schema.properties.templates.anyOf.slice();
            for (let idx = 0; idx < schema.properties.templates.anyOf.length; idx++) {
                if (anyof[idx].enum[0] == payLoad.templateId) {
                    templateName = anyof[idx].title;
                }
            }
        }
        //templateId: children[0].props.formData.templates, if you want all the template dont pass thisid
        // API to get the saved Template and Update the schema back again to re render it
        if (children[0].props.formData.templates) {
            if (this.state.buttonLabel === loadButton) {
                ReactGA.event({
                    category: "templates",
                    action: "templates: load template start",
                    label: "templates: load template start: choose template",
                });
            } else if (this.state.buttonLabel === changeButton) {
                ReactGA.event({
                    category: "templates",
                    action: "templates: change template",
                    label: `templates: change template: ${templateName}`,
                });
            }
            dynamicFormActions.getTemplatesById({ payload: payLoad, templateName: templateName });
        } else {
            const errorObj = { Message: "Please select the template you wish to load", hasCustomMessage: true };
            this.props.globalActions.showGlobalError(errorObj);
        }
    }

    /**
     * @function handleSaveTemplate
     * @param e
     * @description
     * Makes the save API call and save or update the store
     * @ignore
     */
    handleSaveTemplate() {
        const { children, schema, formData, dynamicFormActions } = this.props;
        const formDataUpdated = JSON.parse(JSON.stringify(formData));
        delete formDataUpdated.residentialWarrantyForm.projectDetails.warrantyType;
        delete formDataUpdated.residentialWarrantyForm.projectDetails.dateOfInstallation;
        delete formDataUpdated.residentialWarrantyForm.projectDetails.jobType;
        delete formDataUpdated.residentialWarrantyForm.projectDetails.steepSlopeSq;
        delete formDataUpdated.residentialWarrantyForm.projectDetails.installCost;
        delete formDataUpdated.residentialWarrantyForm.projectDetails.roofPitch;
        delete formDataUpdated.residentialWarrantyForm.projectDetails.myTemplate;

        const successCallBack = (data) => {
            window["AppInsightTrace"].trackTrace(`on template save successCallBack`);
            ReactGA.event({
                category: "templates",
                action: "templates: save template",
                label: `templates: save template: ${children[0].props.formData.templates} successfully saved`,
            });
        };

        const failureCallback = (data) => {
            this.failureCallbackhandler(data);
            // let commonErrorMsg = "";
            // if (data && data.response && data.response.data && data.response.data.Message) {
            //     commonErrorMsg = data.response.data.Message;
            //     window["AppInsightTrace"].trackException(`on delete template Failure: ${commonErrorMsg} `);
            // } else {
            //     const globalErrorMsg = this.props.globalActions.showGlobalError(
            //         (data && data.response && data.response.data) || ""
            //     );
            //     commonErrorMsg = globalErrorMsg.payload.errorMessage;
            //     window["AppInsightTrace"].trackException(`on delete template global Failure: ${commonErrorMsg}`);
            // }
            // ReactGA.event({
            //     category: "templates",
            //     action: "templates: delete template",
            //     label: `templates: delete template: ${children[0].props.formData.templates} not deleted - request cancelled - ${commonErrorMsg}`,
            // });
        };
        if (!(children[0].props && children[0].props.formData && children[0].props.formData.templates)) {
            dynamicFormActions.addFieldIdToStore({
                id: children[0].props.idSchema.templates.$id,
                msg: "Please enter template name",
            });
        } else if (
            validateEmptyForm(formDataUpdated.residentialWarrantyForm.projectDetails, CONFIG["templateUtilities"]) != 0
        ) {
            const payLoad = {
                formlayoutId: 1,
                WarrentyTypeCode: schema["properties"]["templates"]["const"]["warrantyType"],
                templateName: children[0].props.formData.templates,
                templateData: JSON.stringify(formDataUpdated.residentialWarrantyForm.projectDetails),
                successCallBack: successCallBack,
                failureCallback: failureCallback,
                fieldId: children[0].props.idSchema.templates,
            };
            dynamicFormActions.saveTemplate({ payload: payLoad });
        } else {
            const errorObj = { Message: "Cannot save an empty template", hasCustomMessage: true };
            this.props.globalActions.showGlobalError(errorObj);
        }
    }

    render() {
        const [MY_TEMPLATE_TITLE, SAVE_TEMPLATE_TITLE] = ["My Templates", "Save Template"];
        const { children, schema, templateList, classNames } = this.props;
        //image CDN_PATH
        const getimagePath = imagePathurl();
        let isMySavedTemplate = false;

        if (schema.title == MY_TEMPLATE_TITLE) {
            isMySavedTemplate = true;
            this.updateDropDownSchema();
        } else if (SAVE_TEMPLATE_TITLE == schema.title) {
            isMySavedTemplate = false;
        }
        return (
            <>
                <div className={`${classNames} gaf-template-main-container`}>
                    {isMySavedTemplate && schema.title == MY_TEMPLATE_TITLE && (
                        <div>
                            <div className="gaf-mange-profile-control-container">
                                <span
                                    onClick={this.handleManageTemplate}
                                    tabIndex={schema.const.tabIndex}
                                    onKeyPress={handleEnter}
                                >
                                    {schema.properties.templates.const.manageTemplate}
                                    <img
                                        src={`${getimagePath}t-left-thick-red.png`}
                                        className="pl4 gaf-left-thick-red"
                                    />
                                </span>
                            </div>
                            {schema.properties.templates.anyOf && schema.properties.templates.anyOf.length ? (
                                <div className="">
                                    <div className="gaf-template-container ">
                                        {children}
                                        <div className="gaf-template-control-container ">
                                            <button
                                                type="button"
                                                className="gaf-button-template"
                                                onClick={this.handleLoadTemplate}
                                                tabIndex={schema.const.tabIndex + 1}
                                            >
                                                {this.state.buttonLabel}
                                            </button>
                                            <span
                                                onKeyPress={handleEnter}
                                                className="gaf-button gaf-cancel-link "
                                                onClick={this.handleClearTemplate}
                                                tabIndex={schema.const.tabIndex + 1}
                                            >
                                                {schema.properties.templates.const.clearLinkText}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <div className="">
                                        <div className="gaf-template-container ">
                                            <fieldset id="root_residentialWarrantyForm_projectDetails_myTemplate">
                                                <legend id="root_residentialWarrantyForm_projectDetails_myTemplate__title">
                                                    My Templates
                                                </legend>
                                            </fieldset>
                                            <div>{schema.properties.templates.const.noTempateMsg}</div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                    {!isMySavedTemplate && (
                        <div className="">
                            <div className="gaf-template-container ">
                                {children}
                                <div>
                                    <div className="gaf-template-control-container ">
                                        <button
                                            type="button"
                                            className="gaf-button-template"
                                            onClick={this.handleSaveTemplate}
                                            tabIndex={schema.const.tabIndex + 1}
                                        >
                                            {schema.properties.templates.const.buttonlabel}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                {this.state.isManageTemaplatePopup && templateList && Object.keys(templateList).length != 0 && (
                    <div className="gaf-modal-popup-container">
                        <div className="overlay" onClick={this.onCancelPopup}>
                            <div className="gaf-modal-popup"
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}>
                                <div id="close_popup" className="close-menu" onClick={this.onCancelPopup}>
                                    <img
                                        tabIndex={schema.const.tabIndex}
                                        onKeyPress={handleEnter}
                                        className="close-modal-icon"
                                        src={`${getimagePath}close-mobile.png`}
                                        alt="close"
                                    />
                                </div>
                                <div className="modal-popup-title">Manage templates</div>
                                <div className="modal-popup-sub-title">
                                    Please select the template(s) you want to delete
                                </div>
                                <div className="row">
                                    {templateList.map((listItem, id) => {
                                        return (
                                            <div className="col-sm-6" key={`list ${id}`}>
                                                <div className="d-flex mb10">
                                                    <label
                                                        tabIndex={schema.const.tabIndex}
                                                        onKeyPress={handleEnter}
                                                        className={`gaf-template-checkbox  ${
                                                            this.state.checkedItems.includes(listItem.templateId)
                                                                ? "checked"
                                                                : "unchecked"
                                                        }`}
                                                    >
                                                        <input
                                                            checked={this.state.checkedItems.includes(
                                                                listItem.templateId
                                                            )}
                                                            id={id}
                                                            type="checkbox"
                                                            className="hide-checkbox"
                                                            onChange={() =>
                                                                this.onCheckBoxClick(
                                                                    listItem.templateId,
                                                                    listItem.templateName,
                                                                    templateList
                                                                )
                                                            }
                                                        />
                                                    </label>
                                                    <label className="ml25">
                                                        {listItem.warrentyTypeCode + " " + listItem.templateName}
                                                    </label>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className="text-center">
                                    <button
                                        type="button"
                                        className="modal-popup-btn mt20"
                                        onClick={this.confirmDeleteTempalate}
                                        onKeyPress={handleEnter}
                                        tabIndex={schema.const.tabIndex}
                                    >
                                        DELETE TEMPLATES
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {this.state.isManageTemaplatePopup &&
                    typeof templateList != "string" &&
                    Object.keys(templateList).length == 0 && (
                        <div className="gaf-modal-popup-container">
                            <div className="overlay" onClick={this.onCancelPopup}>
                                <div className="gaf-modal-popup" onClick={(e) => {
                                    e.stopPropagation();
                                }}>
                                    <div id="close_popup" className="close-menu" onClick={this.onCancelPopup}>
                                        <img
                                            tabIndex={schema.const.tabIndex}
                                            onKeyPress={handleEnter}
                                            className="close-modal-icon"
                                            src={`${getimagePath}close-mobile.png`}
                                            alt="close"
                                        />
                                    </div>
                                    <div className="modal-popup-title">Manage templates</div>
                                    <div className="modal-popup-sub-title">
                                        You have no saved templates. To save templates for future use, please select the
                                        items in the product details section that you want to save to the template,
                                        scroll to the bottom of this page, and name and save the template
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
            </>
        );
    }
}

export function mapStateToProps(state) {
    return {
        formId: state.dynamicFormInfo.formId,
        formData: state.dynamicFormInfo.warrantyInfo,
        savedTemplates: state.dynamicFormInfo.templates,
        warrantyId: state.dynamicFormInfo.warrantyId,
        formLayout: state.dynamicFormInfo.layoutResponse,
        templateList: state.dynamicFormInfo.templateList,
        error: state.globalInfo.globalError,
        warrentyData: state.dynamicFormInfo.layoutResponse.WarrantyData,
        menuKeys: state.dynamicFormInfo.menuKeys,
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        dynamicFormActions: bindActionCreators(dynamicFormActionCreators, dispatch),
        globalActions: bindActionCreators(globalActionsCreator, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SaveTemplate);
